const permissionConfig = [
  {
    role: "Admin",
    show: [
      "Dashboard",
      "Settings",
      "Services",
      "Work List",
      "My Work List",
      "Languages",
      "Location",
      "Available-Shifts",
      "Days-Available",
      "Education-Levels",
      "Hospital-Facilities",
      "Carepreneur",
      "Facility-Service",
      "Interaction",
      "States",
      "Districts",
      "Cities",
      "Co-Ordinators",
      "Managers",
      "Lead-Source",
      "Interaction-Type",
      "Interaction-Channel",
      "Interaction-Outcome",
      "FollowUpMode",
      "ResourceType",
      "AssessmentType",
      "AssessmentMode",
      "RiskCategory",
      "ResourceCategory",
      "Relations",
      "Tariffs",
      "Carepreneur",
      "Hospital",
      "Marketing",
      "Blog Categories",
      "Blog Posts",
      "Contacts",
      "Seo-Url",
    ],
  },
  {
    role: "lead_coordinator",
    show: ["Dashboard", "Work List", "My Work List", "Interaction"],
  },
];

export default permissionConfig;
